/* A section that opens when it is asked for.
   OWNED BY ITEM 4 OF docs/plan/00-prestavba-2026-08.md.

   Built on <details>, not on a div and a state variable: it is open to
   in-page search, to the keyboard and to printing without any of that having
   to be written again. */

import type { ReactNode } from "react";

export function Collapse({ title, open, children }: {
  title: ReactNode; open?: boolean; children: ReactNode;
}) {
  return (
    <details className="fold" open={open}>
      <summary className="fold-head">
        <span className="fold-title">{title}</span>
        <span className="fold-mark" aria-hidden="true" />
      </summary>
      <div className="fold-body">{children}</div>
    </details>
  );
}
